var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-container",
        { staticClass: "text-center" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-select", {
                    attrs: {
                      "data-cy": "FormJobListingCandidate-candidateId",
                      filled: "",
                      label: _vm.$$t("candidateId"),
                      items: _vm.items,
                    },
                    model: {
                      value: _vm.localJobListingCandidate.candidateId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localJobListingCandidate,
                          "candidateId",
                          $$v
                        )
                      },
                      expression: "localJobListingCandidate.candidateId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-select", {
                    attrs: {
                      "data-cy": "FormJobListingCandidate-jobListingId",
                      filled: "",
                      label: _vm.$$t("jobListingId"),
                      items: _vm.items,
                    },
                    model: {
                      value: _vm.localJobListingCandidate.jobListingId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localJobListingCandidate,
                          "jobListingId",
                          $$v
                        )
                      },
                      expression: "localJobListingCandidate.jobListingId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-select", {
                    attrs: {
                      "data-cy": "FormJobListingCandidate-stageId",
                      filled: "",
                      label: _vm.$$t("stageId"),
                      items: _vm.items,
                    },
                    model: {
                      value: _vm.localJobListingCandidate.stageId,
                      callback: function ($$v) {
                        _vm.$set(_vm.localJobListingCandidate, "stageId", $$v)
                      },
                      expression: "localJobListingCandidate.stageId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-select", {
                    attrs: {
                      "data-cy": "FormJobListingCandidate-taskId",
                      filled: "",
                      label: _vm.$$t("taskId"),
                      items: _vm.items,
                    },
                    model: {
                      value: _vm.localJobListingCandidate.taskId,
                      callback: function ($$v) {
                        _vm.$set(_vm.localJobListingCandidate, "taskId", $$v)
                      },
                      expression: "localJobListingCandidate.taskId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end mb-6" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 btn-cancel",
                  attrs: {
                    color: "default",
                    outlined: "",
                    "data-cy": "FormJobListingCandidate-button-cancel",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: {
                    color: "primary",
                    type: "submit",
                    loading: _vm.isSaving,
                    "data-cy": "FormJobListingCandidate-button-save",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }